import { render, staticRenderFns } from "./FFormOOI.vue?vue&type=template&id=49c50530&"
import script from "./FFormOOI.vue?vue&type=script&lang=js&"
export * from "./FFormOOI.vue?vue&type=script&lang=js&"
import style0 from "./FFormOOI.vue?vue&type=style&index=0&id=49c50530&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports